import { executeRequest, Request } from '@jfs/network'
import { capitaliseFirstCharAndRestToLowerCase, isOsMobile } from '../util/util'
import { getMerchantMetaDataRequestBody } from './../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const parseDataAsPerSearchMerchantResponse = (entityData: any) => {
  console.log('🚀 ~ parseDataAsPerSearchMerchantResponse ~ entityData:', entityData)
  return {
    status: capitaliseFirstCharAndRestToLowerCase(
      entityData?.entityType === 'GROUP' && !entityData?.merchantStatus ? 'ACTIVE' : entityData?.merchantStatus ?? '',
    ),
    userStatus: capitaliseFirstCharAndRestToLowerCase(entityData?.status ?? ''),
    businessName:
      entityData?.entityType === 'GROUP' && !entityData?.businessName ? 'JPSL' : entityData?.businessName ?? '',
    name: capitaliseFirstCharAndRestToLowerCase(entityData?.firstName ?? ''),
    mid: String(entityData?.entityId) ?? '',
    tId: '',
    accessProfileId: entityData?.accessProfileId ?? '',
    type: entityData?.entityType ?? '',
    jfsUserId: String(entityData?.jfsUserId),
    vpa: entityData?.businessVpa ?? '',
    bankAccount: entityData?.bankAccount,
    contact: entityData?.contact,
    acceptedPayments: [],
    limits: [],
    age: '',
    authorisedSignatory: '',
    dailyTransactionVolume: '',
  }
}

const responseParser = (data: any) => {
  const entityData = data?.userEntityList
  const activeUsers = []
  entityData?.map((item: any) => {
    // TODO: don't consider terminated user
    if (item?.status?.toLowerCase() !== 'terminated' && (!isOsMobile() || item.entityType !== 'GROUP')) {
      activeUsers.push(parseDataAsPerSearchMerchantResponse(item))
    }
  })
  return activeUsers
}

const GetMerchantMetaData = (mid: string, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.searchMerchantMetaData,
    body: getMerchantMetaDataRequestBody(mid),
    method: 'POST',
  }
  return executeRequest(request).then(({ data }) => {
    if (data?.error) {
      throw data?.error
    } else {
      return responseParser(data)
    }
  })
}

export { GetMerchantMetaData }
